module.exports = __webpack_public_path__ + "img/taozi.ac40c336.png";